import { type FC, useState } from "react";
import { Collapse, IconButton, Paper, Stack, Typography } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import type { ClientFilters } from "../clientFilters";
import ClientFiltersForm from "./ClientFiltersForm";
import { useDraftFilters } from "./useDraftFilters";

interface Props {
  appliedFilters: ClientFilters;
  onApply: (filters: ClientFilters) => void;
  onReset: () => void;
}

const ClientFiltersPanel: FC<Props> = ({ appliedFilters, onApply, onReset }) => {
  const [open, setOpen] = useState(true);
  const { draftFilters, updateDraft } = useDraftFilters(appliedFilters);

  return (
    <Paper elevation={0} sx={{ mb: 2, border: "1px solid rgba(0,0,0,0.08)", borderRadius: 2, overflow: "hidden" }}>
      <Stack
        direction="row"
        sx={{ alignItems: "center", justifyContent: "space-between", px: 2, py: 1.25, bgcolor: "rgba(0,0,0,0.02)" }}
      >
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <FilterListIcon color="action" fontSize="small" />
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            Filtry
          </Typography>
        </Stack>
        <IconButton size="small" onClick={() => setOpen((previous) => !previous)} aria-label="Przełącz filtry">
          {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Stack>
      <Collapse in={open}>
        <ClientFiltersForm
          filters={draftFilters}
          onChange={updateDraft}
          onApply={() => onApply(draftFilters)}
          onReset={onReset}
          onAddPredefinedFilter={(value) => onApply({ ...draftFilters, has: [...draftFilters.has, value] })}
        />
      </Collapse>
    </Paper>
  );
};

export default ClientFiltersPanel;
